<template>
  <div class="text-xs-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      max-width="480"
      offset-x
      lazy
    >
      <template #activator="{ on }">
        <v-btn flat icon v-on="on">
          <v-icon>tune</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-layout wrap row pa-3>
          <!-- Filtro por Tipo -->
          <v-flex xs12 px-2>
            <v-autocomplete
              v-model="localFilters.type"
              :items="types"
              :label="
                $t('action.actions.select', {
                  field: $tc('models.typeNotification'),
                })
              "
              clearable
              no-filter
              :data-vv-name="$tc('models.notification')"
            />
          </v-flex>

          <!-- Filtro por Entidad-->
          <v-flex xs12 px-2>
            <v-autocomplete
              v-model="localFilters.entityId"
              :items="entityList"
              :label="
                $t('action.actions.select', { field: $tc('models.entity') })
              "
              :loading="$store.state.entities.loading"
              clearable
              no-filter
              :search-input.sync="searchEntity"
              @change="handleTeamsUpdate"
            >
              <template #selection="data">
                <v-chip
                  color="white"
                  :selected="data.selected"
                  class="chip--select-multi"
                >
                  <v-avatar>
                    <img :src="data.item.logo" />
                  </v-avatar>
                  {{ data.item.text }}
                </v-chip>
              </template>
              <template #item="data">
                <v-list-tile-avatar>
                  <img :src="data.item.logo" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.text" />
                </v-list-tile-content>
              </template>
            </v-autocomplete>
          </v-flex>

          <!-- Filtro por Equipo -->
          <v-flex xs12 px-2>
            <v-autocomplete
              v-model="localFilters.teamId"
              :items="teamList"
              :label="
                $t('action.actions.select', { field: $tc('models.team') })
              "
              :loading="$store.state.teams.loading"
              clearable
              no-filter
              :search-input.sync="searchTeam"
            >
              <template #selection="data">
                <v-chip
                  color="white"
                  :selected="data.selected"
                  class="chip--select-multi"
                >
                  <v-avatar>
                    <img :src="data.item.logo" />
                  </v-avatar>
                  {{ data.item.text }}
                </v-chip>
              </template>
              <template #item="data">
                <v-list-tile-avatar>
                  <img :src="data.item.logo" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.text" />
                  <v-list-tile-sub-title>
                    {{ data.item.entity }} -
                    {{ data.item.category }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
              <!--          -->
            </v-autocomplete>
          </v-flex>

          <!-- Filtro por Fecha -->
          <v-flex xs12 lg6>
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              full-width
              max-width="290"
            >
              <template #activator="{ on }">
                <v-text-field
                  :value="dateStart"
                  clearable
                  :label="$t('fields.tournaments.startAt')"
                  prepend-icon="event"
                  readonly
                  @click:clear="localFilters.dateStart = ''"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="localFilters.dateStart"
                first-day-of-week="1"
                :locale="$store.state.languages.iso()"
                @change="menu1 = false"
              />
            </v-menu>
          </v-flex>
          <v-flex xs12 lg6>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              full-width
              max-width="290"
              locale="es-ES"
            >
              <template #activator="{ on }">
                <v-text-field
                  :value="dateEnd"
                  clearable
                  prepend-icon="event"
                  :label="$t('fields.tournaments.endAt')"
                  readonly
                  @click:clear="localFilters.dateEnd = ''"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="localFilters.dateEnd"
                first-day-of-week="1"
                :locale="$store.state.languages.iso()"
                @change="menu2 = false"
              />
            </v-menu>
          </v-flex>
        </v-layout>

        <v-divider />
        <v-card-actions>
          <v-spacer />

          <v-btn
            color="primary"
            flat
            :loading="$store.state.matches.loading"
            @click="search"
          >
            {{ $t('action.buttons.search') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { debounce } from 'debounce'
import { mapState, mapGetters } from 'vuex'
import { formatDate } from '@/helpers'

export default {
  name: 'NotificationsFilters',
  data: () => ({
    menu: false,
    typeList: [],
    entityList: [],
    teamList: [],
    searchEntity: '',
    searchTeam: '',
    searchType: '',
    menu1: false,
    menu2: false,
  }),
  watch: {
    'localFilters.entityId': {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          this.localFilters.teamId = ''
          this.debounceTeams()
        }
      },
      immediate: true,
      deep: true,
    },
    searchEntity(val) {
      if (!this.filters.entityId) {
        this.debounceEntities({ match: val, set: false })
      }
    },
    searchTeam() {
      if (!this.filters.teamId) {
        this.debounceTeams()
      }
    },
  },
  computed: {
    ...mapState({
      filters: (state) => state.notifications.filters,
    }),
    ...mapGetters({
      types: 'notifications/types',
    }),
    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$store.commit('notifications/setFilters', value)
      },
    },
    dateStart() {
      return formatDate(this.localFilters.dateStart)
    },
    dateEnd() {
      return formatDate(this.localFilters.dateEnd)
    },
  },
  methods: {
    handleTeamsUpdate() {
      this.localFilters.teamId = ''
    },
    search() {
      this.debounceFetch('notifications')
      this.menu = false
      this.$emit('search')
    },
    debounceEntities: debounce(function (params) {
      if (!params) params = {}
      params.fetchData = true
      this.$store
        .dispatch('entities/fetchSelectList', params)
        .then((result) => {
          this.entityList = result
        })
    }, 700),
    debounceTeams: debounce(function () {
      let params = { match: this.searchTeam, set: false }
      if (this.filters.entityId) params.entityId = this.filters.entityId
      this.$store.dispatch('teams/fetchSelectList', params).then((result) => {
        this.teamList = result
      })
    }, 700),
  },
}
</script>
